import { createFileRoute } from "@tanstack/react-router";
import { Section, SectionHeader } from "@/components/Section";
import { CTASection } from "@/components/CTASection";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { Reveal } from "@/components/Reveal";
import { Tilt3D } from "@/components/Tilt3D";

export const Route = createFileRoute("/metodo-svg")({
  head: () => ({
    meta: [
      { title: "Método SVG Multimídia | Estratégia para Aparecer no Google" },
      { name: "description", content: "Conheça o método da SVG Multimídia para melhorar presença no Google, otimizar fichas, criar sites estratégicos e gerar mais oportunidades orgânicas." },
      { property: "og:title", content: "Método SVG | SVG Multimídia" },
      { property: "og:description", content: "Como transformamos presença digital em oportunidades reais." },
      { property: "og:url", content: "/metodo-svg" },
    ],
    links: [{ rel: "canonical", href: "https://www.svgmultimidia.com.br/metodo-svg" }],
  }),
  component: Metodo,
});

const steps = [
  { n: "01", t: "Diagnóstico", d: "Análise de presença atual, concorrência, Ficha do Google, site, buscas e oportunidades." },
  { n: "02", t: "Planejamento", d: "Definição de palavras-chave, prioridades e roadmap estratégico." },
  { n: "03", t: "Execução", d: "Ajustes técnicos, otimizações, estrutura e conversão." },
  { n: "04", t: "Conteúdo", d: "Páginas, artigos e materiais com intenção de busca clara." },
  { n: "05", t: "Autoridade", d: "Sinais consistentes, atualizações e fortalecimento da marca." },
  { n: "06", t: "Acompanhamento", d: "Monitoramento de buscas, cliques, chamadas e mensagens." },
  { n: "07", t: "Conversão", d: "Melhoria contínua dos pontos que transformam visita em contato." },
];

function Metodo() {
  return (
    <>
      <section className="hero-bg">
        <div className="container-svg pt-12 pb-16 md:pt-20 md:pb-20">
          <Breadcrumbs items={[{ label: "Início", to: "/" }, { label: "Método SVG" }]} />
          <div className="mt-6 max-w-3xl">
            <span className="eyebrow">Método SVG</span>
            <h1 className="mt-4 text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
              <span className="text-gradient">O método da SVG para transformar presença digital em oportunidades</span>
            </h1>
            <p className="mt-6 text-base text-muted-foreground md:text-lg">
              Um processo claro, prático e consultivo. Cada etapa pensada para empresas que querem aparecer melhor no Google e receber mais contatos qualificados.
            </p>
          </div>
        </div>
      </section>

      <Section>
        <SectionHeader eyebrow="As etapas" title="Como conduzimos o trabalho" />
        <ol className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {steps.map((s, idx) => (
            <Reveal as="li" key={s.n} delay={(idx % 3) as 0 | 1 | 2}>
              <Tilt3D>
                <div className="card-glass">
                  <span className="font-display text-3xl font-bold text-primary">{s.n}</span>
                  <h2 className="mt-3 text-lg font-semibold">{s.t}</h2>
                  <p className="mt-2 text-sm text-muted-foreground">{s.d}</p>
                </div>
              </Tilt3D>
            </Reveal>
          ))}
        </ol>
      </Section>

      <CTASection />
    </>
  );
}